module.exports = __webpack_public_path__ + "static/media/community.c23f58cd.png";